<template>
  <div class="Home">
    <div class="totalHead">
      <div style="float: right">
        <div style="float: right" class="rightData">
          <p>
            {{ this.lwhjNum.zongNum}}<br />
            <span>总量</span>
          </p>
          <p>
            {{ this.lwhjNum.jinNum}} <br />
            <span>今日新增</span>
          </p>
          <p>
              {{ this.lwhjNum.sevenNum}} <br/>
            <span>7日新增</span>
          </p>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="left">
        <div class="circleRing">
          <p class="firCircle shine">
            <img
              src="../../assets/Starting/img-two/video.png"
              style="width: 2vw; height: 2vw"
            />
          </p>
          <p class="line1"></p>
          <p class="secCircle shine">
            <img
              src="../../assets/Starting/img-two/news.png"
              style="width: 3vw; height: 3vw"
            />
          </p>
          <p class="line2"></p>
          <p class="thiCircle shine" @click="tobigLW"></p>
          <p class="smallOne" @click="tobigLW">
            <img
              src="../../assets/Starting/img-two/wechat.png"
              style="width: 1.2vw; height: 1.2vw"
            />
          </p>
          <p class="smallTwo" @click="tobigLW">
            <img
              src="../../assets/Starting/img-two/weibo.png"
              style="width: 1.2vw; height: 1.2vw"
            />
          </p>
          <p class="line3"></p>
          <p class="fouCircle shine">
            <img src="../../assets/Starting/img-two/shousuo.png" />
          </p>
          <p class="timer" data-to="3620" data-speed="1500"></p>
        </div>
      </div>
      <div class="right">
        <div class="wx_part">
          <vue-seamless-scroll
            :data="listData"
            class="seamless-warp"
            :class-option="defaultOption"
          >
            <ul class="wx_item">
              <li v-for="(item, index) in listData.slice(0,10)" :key="index">
                <div class="wx_title" @click="getLos(item.netURL)">
                  {{ item.title }}
                </div>
                <div class="wx_bottom">       
              <div style="width:0px" v-if="item.imgs.length==0"></div>
               <div v-else>
                <img :src="item.imgs[0]" :class="item.imgs.length==0?'seven_img':'bottom_img'"  alt="" />
                 </div>
              
                  <div class="wx_distance">{{ item.content }}</div>
                  <div class="wx_date">{{ item.newsTime | formatDate }}</div>
                </div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="wx_part cont">
          <vue-seamless-scroll
            :data="listData"
            class="seamless-warp"
            :class-option="defaultOption"
          >
            <ul class="wx_item">
              <li v-for="(item, index) in listData.slice(10,20)" :key="index">
                <div class="wx_title" @click="getLos(item.netURL)">
                  {{ item.title }}
                </div>
                <div class="wx_bottom">
                  <div style="width:0px" v-if="item.imgs.length==0"></div>
               <div v-else>
                <img :src="item.imgs[0]" :class="item.imgs.length==0?'seven_img':'bottom_img'"  alt="" />
                 </div>
                  <div class="wx_distance">{{ item.content }}</div>
                  <div class="wx_date">{{ item.newsTime | formatDate }}</div>
                </div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="search_part">
          <div class="search_top">
            <div class="search_wx">热搜新闻</div>
            <div class="wx_time">
              <div class="time_list">
                <div
                  class="list_li"
                  v-for="(item, index) in xw_list"
                  :key="index"
                >
                  <div
                    :id="gend(index)"
                    @click="getup(item.NET_URL)"
                    class="li_p"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="search_bottom">
            <div class="search_wb">新闻热词</div>
            <div class="moon_time">
              <div
                class="onst_li"
                :id="time(index)"
                v-for="(item, index) in boxList"
                :key="index"
              >
                {{ item.word }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { TwoCont, TwoEve, hotNum, Twonum } from "../../api/re";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      lwhjNum: {
       zongNum:0,   //总量
       sevenNum:0,//七日新增
       jinNum:0 ,  //今日新增

      },
      listData: [],
      xw_list: [],
      boxList: [],
    };
  },
  // 监听属性 类似于data概念
  computed: {
    defaultOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    this.lond();
  },
  methods: {
    gend(index) {
      return "person_" + index;
    },
    time(index) {
      return "very" + index;
    },
    lond() {
      TwoCont({
        dataBase: "tw",
      }).then((res) => {
        this.listData = res.data.data;
        console.log(this.listData,'图文汇聚数据')
      });
      TwoEve({
        dataBase: "xw",
      }).then((res) => {
        this.xw_list = res.data.data[0];
      });
      hotNum({
        type: 4,
      }).then((res) => {
        this.boxList = res.data.data;
      });
      Twonum({
        dataBase: "tw",
        timeType: 0,
      }).then((res) => {
    this.lwhjNum.zongNum=res.data.data.totalhits;
      });
      Twonum({
        dataBase: "tw",
        timeType: 1,
      }).then((res) => {
     this.lwhjNum.jinNum=res.data.data.totalhits;
      });
      Twonum({
        dataBase: "tw",
        timeType: 0,
      }).then((res) => {
     this.lwhjNum.sevenNum=res.data.data.totalhits;
      });
    },
    getLos(url) {
      window.location.href = url;
    },
    getup(url) {
      window.location.href = url;
    },
    tobigLW() {
      this.$router.push("/twoNews");
    },
  },
};
</script>

<style lang="scss" scoped>
.seven_img{
  width: 0;
  height: 0;
}
.Home {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/Starting/img-two/newTw.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;

  /*** 顶部 ***/
  .totalHead {
    width: 100vw;
    height: 15vh;

    .rightData {
      margin-top: 5vh;
      color: #01e1eb;
      text-align: center;
    }

    .rightData p {
      display: inline-block;
      font-size: 2.85vw;
      font-family: big-icon;
      line-height: 2vw;
    }

    .rightData p:nth-child(2) {
      margin-left: 2.5vw;
      color: #db0196;
    }

    .rightData p:nth-child(3) {
      margin-right: 2vw;
      margin-left: 2.5vw;
    }

    .rightData span {
      font-size: 1vw;
    }
  }
  .main {
    height: 85vh;
    width: 100vw;
    display: flex;
    justify-content: space-around;
    align-items: center;

    /** 左边部分 **/
    .left {
      width: 15vw;
      height: 100vh;

      /***主区域的圆圈集合***/
      .circleRing {
        height: 55vh;
        width: 8%;
        position: relative;
        top: 30%;
        left: 25%;
      }
      .firCircle {
        width: 2.7vw;
        height: 2.7vw;
        border: 0.15vw dotted #00f6ff;
        border-radius: 50%;
        // cursor: pointer;
      }

      .secCircle {
        position: absolute;
        width: 4.2vw;
        height: 4.2vw;
        border: 0.15vw dotted #00f6ff;
        border-radius: 50%;
        top: 11vh;
        left: 3.2vw;
      }
      .secCircle {
        animation: scaleout 1.5s ease infinite; /*调用已定义好的动画lefteaseinAnimate，全程运行时间1S，进入的速度曲线为ease，只播放一次*/
        -webkit-animation: scaleout 1.5s ease infinite;
        -ms-animation: scaleout 1.5s ease infinite;
        -o-animation: scaleout 1.5s ease infinite;
        -moz-animation: scaleout 1.5s ease infinite;

        /*规定动画的最后状态为结束状态*/
        animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;
        -o-animation-fill-mode: forwards;
        -ms-animation-fill-mode: forwards;
        -moz-animation-fill-mode: forwards;
      }

      .thiCircle {
        width: 3.2vw;
        height: 3.2vw;
        border: 0.15vw dotted #00f6ff;
        border-radius: 50%;
        position: absolute;
        top: 21.4vh;
      }

      .fouCircle {
        width: 3.2vw;
        height: 3.2vw;
        border: 0.15vw dotted #00f6ff;
        border-radius: 50%;
        position: absolute;
        top: 33vh;
        left: 1.9vw;
      }

      .line1 {
        height: 0px;
        border: 1px solid #00f6ff;
        width: 3.9vw;
        transform: rotate(52deg);
        -o-transform: rotate(52deg);
        -moz-transform: rotate(52deg);
        -webkit-transform: rotate(52deg);
        position: absolute;
        left: 1.5vw;
        top: 8vh;
      }

      .line2 {
        height: 0px;
        border: 1px solid #00f6ff;
        width: 2.2vw;
        transform: rotate(120deg);
        -o-transform: rotate(120deg);
        -moz-transform: rotate(120deg);
        -webkit-transform: rotate(120deg);
        position: absolute;
        left: 2.3vw;
        top: 20.5vh;
      }

      .line3 {
        height: 0px;
        border: 1px solid #00f6ff;
        width: 3vw;
        transform: rotate(68deg);
        -o-transform: rotate(68deg);
        -moz-transform: rotate(68deg);
        -webkit-transform: rotate(68deg);
        position: absolute;
        left: 1.7vw;
        top: 30.5vh;
      }

      .shine:hover {
        cursor: pointer;
        -webkit-animation: scaleout 1.3s infinite ease-in-out;
        animation: scaleout 1.3s infinite ease-in-out;
      }

      @-webkit-keyframes scaleout {
        from {
          border-color: rgba(0, 246, 255, 0.8);
          transform: scale(1);
          -webkit-transform: scale(1);
        }
        to {
          border-color: rgba(0, 246, 255, 1);
          transform: scale(1.1);
          -webkit-transform: scale(1.1);
        }
      }

      @keyframes scaleout {
        from {
          border-color: rgba(0, 246, 255, 0.8);
          transform: scale(1);
          -webkit-transform: scale(1);
        }
        to {
          border-color: rgba(0, 246, 255, 1);
          transform: scale(1.1);
          -webkit-transform: scale(1.1);
        }
      }

      .shine {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .smallOne,
      .smallTwo {
        display: inline-block;
        cursor: pointer;
        width: 1.4vw;
        height: 2.6vh;
        border: 0.15rem dotted #00f6ff;
        border-radius: 50%;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .smallOne {
        top: 22.5vh;
        left: 0.3vw;
      }

      .smallTwo {
        top: 24vh;
        left: 1.55vw;
      }
    }

    /**右边部分**/
    .right {
      width: 85vw;
      height: 80vh;
      display: flex;
      justify-content: space-between;

      /* 微信部分 */
      .wx_part {
        width: 35vw;
        height: 72vh;
        .seamless-warp {
          height: 100%;
          overflow: hidden;
        }
        .wx_item {
          height: 100%;
          li {
            border-bottom: 1px solid #01b3e2;
            padding: 1.4vh 0.25vw;
            .wx_title {
              font: normal 1vw/1.3vw Microsoft Yahei;
              color: #fff;
              min-height: 5vh;
              padding-bottom: 0.7vh;
              cursor: pointer;
              display: block;
            }
            .wx_bottom {
              width: 100%;
              display: flex;
              color: #00f6ff;
              display: flex;
              justify-content: space-around;
              align-items: center;
              .bottom_img {
                width: 60px;
                height: 60px;
              }
              .wx_distance {
                width: 75%;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                padding-left: 10px;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              .wx_date {
                width: 20%;
                padding-left: 8px;
                font-size: 14px;
              }
            }
          }
        }
      }
      .cont {
        position: relative;
        left: 2vw;
      }
      /* 微博部分 */
      .wb_part {
        width: 35vw;
        height: 72vh;
        // border: 5px solid green;
        margin-left: 4vw;
        .seamless-warp {
          height: 100%;
          overflow: hidden;
        }
        .wx_item {
          height: 100%;
          li {
            border-bottom: 1px solid #01b3e2;
            padding: 1.4vh 0.25vw;
            .wx_title {
              font: normal 1vw/1.3vw Microsoft Yahei;
              color: #fff;
              min-height: 5vh;
              padding-bottom: 0.7vh;
              cursor: pointer;
              display: block;
            }
            .wx_bottom {
              width: 100%;
              display: flex;
              color: #00f6ff;
              display: flex;
              justify-content: space-around;
              align-items: center;
              .bottom_img {
                width: 60px;
                height: 60px;
              }
              .wx_distance {
                width: 50%;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              .wx_date {
                width: 20%;
              }
            }
          }
        }
      }
      /* 热搜部分 */
      .search_part {
        width: 30vw;
        height: 80vh;
        .search_top {
          width: 100%;
          height: 40vh;
          .search_wx {
            color: #fff;
            font-family: Helvetica, tahoma, arial, Microsoft YaHei, 微软雅黑,
              sans-serif;
            font-size: 1.5vw;
            font-weight: 700;
            margin-left: 140px;
            margin-top: 4px;
          }

          .wx_time {
            width: 100%;
            height: 100%;
            padding: 20px;
            font-size: 12px;

            .time_list {
              margin: 0 auto;
              position: relative;
              left: 10px;
              width: 76%;
              top: 5px;
              height: 100%;
              overflow: hidden;

              .list_li {
                width: 100%;
                height: 30px;
                cursor: pointer;
              }
              .li_p {
                width: 100%;
                font-family: Microsoft YaHei;
                font-weight: 400;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: #fff;
              }

              #person_0 {
                color: #e71f19;
              }
              #person_1 {
                color: #ef8119;
              }
              #person_2 {
                color: #3aae36;
              }
            }
          }
        }
        .search_bottom {
          width: 100%;
          height: 40vh;
          .search_wb {
            color: #fff;
            font-family: Helvetica, tahoma, arial, Microsoft YaHei, 微软雅黑,
              sans-serif;
            font-size: 1.5vw;
            font-weight: 700;
            margin-left: 140px;
            margin-top: 50px;
          }
          .moon_time {
            width: 70%;
            height: 29vh;
            position: relative;
            left: 90px;
            top: 20px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-wrap: wrap;
            overflow: hidden;
          }

          .onst_li {
            width: 35%;
            height: 65px;
            text-align: center;
            line-height: 65px;
            color: #fff;
            margin: 0.5px;
            font-size: 14px;
          }
          #very0 {
            background: #6d91cf;
            width: 66%;
          }
          #very1 {
            background: #3064bb;
            width: 33%;
          }
          #very2 {
            background: #6d91cf;
            width: 33%;
          }
          #very3 {
            background: #3064bb;
            width: 33%;
          }
          #very4 {
            background: #6d91cf;
            width: 33%;
          }
          #very5 {
            background: #3064bb;
            width: 33%;
          }
          #very6 {
            background: #6d91cf;
            width: 33%;
          }
          #very7 {
            background: #3064bb;
            width: 33%;
          }
          #very8 {
            background: #6d91cf;
            width: 33%;
          }
          #very9 {
            background: #3064bb;
            width: 33%;
          }
          #very10 {
            background: #6d91cf;
            width: 33%;
          }
          #very11 {
            background: #3064bb;
            width: 33%;
          }
        }
      }
    }
  }
}
</style>
